<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, email } from '@vuelidate/validators';
import router from '../../../../../index';
import PageHeader from '../../../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      email: '',
      alertMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    email: { required, email },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const emailChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'email',
              email: this.email,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: emailChannel.id,
          },
        });
      } catch (error) {
        const errorMessage = error?.message;
        this.alertMessage =
          errorMessage ||
          this.$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.API.ERROR_MESSAGE');
        useAlert(this.alertMessage, {type: 'error'});
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full flex flex-col gap-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.DESC')"
    />
    <form class="flex w-full flex-col" @submit.prevent="createChannel()">
      <!-- Layout 2 cột -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Cột trái: Channel Name -->
        <div>
          <label :class="{ error: v$.channelName.$error }">
            {{ $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CHANNEL_NAME.LABEL') }}
            <input
              v-model="channelName"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
              "
              @blur="v$.channelName.$touch"
            />
            <span v-if="v$.channelName.$error" class="message">{{
              $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CHANNEL_NAME.ERROR')
            }}</span>
          </label>
        </div>

        <!-- Cột phải: Email -->
        <div>
          <label :class="{ error: v$.email.$error }">
            {{ $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.EMAIL.LABEL') }}
            <input
              v-model="email"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.EMAIL.PLACEHOLDER')"
              @blur="v$.email.$touch"
            />
            <span v-if="v$.email.$error" class="message">{{
              $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.EMAIL.ERROR')
            }}</span>
          </label>         
        </div>
      </div>

      <!-- Submit Button -->
      <div class="w-full flex justify-center mt-12">
        <woot-submit-button
          class="!bg-n-bluegray-4 !text-white rounded-lg"
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.EMAIL_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<style scoped>
.help-text {
  font-size: 0.875rem;
  color: #6b7280;
}
</style>